import { html } from 'lit';
const GoogleMap =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' d="M9.084 17.075q.81 1.052 1.469 2.207c.374.724.53 1.215.804 2.087.168.482.32.626.646.626.355 0 .516-.245.64-.623.26-.824.462-1.452.782-2.046.629-1.147 1.41-2.166 2.177-3.146.208-.277 1.55-1.891 2.155-3.166 0 0 .743-1.4.743-3.354 0-1.828-.733-3.097-.733-3.097l-2.11.576-1.28 3.44-.318.475-.063.086-.084.108-.148.172-.212.215-1.14.948-2.853 1.679z"/><path fill='currentColor' d="M6.14 12.78c.697 1.62 2.04 3.045 2.948 4.296l4.824-5.826s-.68.906-1.913.906c-1.373 0-2.482-1.118-2.482-2.528 0-.966.57-1.63.57-1.63l-3.275.894zM13.966 3.3a6.5 6.5 0 0 1 3.803 3.262l-3.856 4.684s.57-.676.57-1.636c0-1.443-1.19-2.52-2.478-2.52-1.217 0-1.916.904-1.916.904v-2.95z"/><path fill='currentColor' d="M7.024 5.37C7.981 4.201 9.665 3 11.987 3c1.126 0 1.975.301 1.975.301l-3.877 4.696H7.34z"/><path fill='currentColor' d="M6.14 12.78S5.5 11.5 5.5 9.647c0-1.75.668-3.28 1.524-4.279l3.063 2.628z"/>
  </svg>
`;
export default GoogleMap;
